/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import './super-pro-measurements.scss';

/* eslint-disable import/no-unresolved, import/default */

import superProMeasurementsDialog from './super-pro-measurements.tpl.html';
import superProMeasurementAddDialog from './super-pro-measurement-add.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

export default angular.module('agrolog.farmer.superProMeasurements', [])
    .directive('superProMeasurements', SuperProMeasurements)
    .name;

/*@ngInject*/
function SuperProMeasurements() {
    return {
        restrict: "E",
        scope: true,
        bindToController: {
            ctx: '=',
            device: '='
        },
        controller: SuperProMeasurementsController,
        controllerAs: 'vm',
        templateUrl: superProMeasurementsDialog
    };
}

/* eslint-disable angular/angularelement */

/*@ngInject*/
function SuperProMeasurementsController($scope, $mdDialog, $document, $log, types, agTypes, agUtils, userService, timeService) {// eslint-disable-line

    let vm = this;

    vm.loading = false;
    vm.measurements = [];

    vm.isCustomer = isCustomer;
    vm.getCropName = getCropName;
    vm.openAddMeasurementDialog = openAddMeasurementDialog;
    vm.openEditMeasurementDialog = openEditMeasurementDialog;

    vm.measurementsSubscriptionOptions = {
        callbacks: {
            onDataUpdated: onDataUpdated,
            onDataUpdateError: onDataUpdateError,
            dataLoading: (subscription) => {
                vm.loading = subscription.loadingData;
            }
        },
        timeWindowConfig: timeService.defaultTimewindow(),
        useDashboardTimewindow: false
    };

    vm.measurementsSubscriptionOptions.timeWindowConfig.aggregation.type = types.aggregation.none.value;
    vm.measurementsSubscriptionOptions.timeWindowConfig.realtime.timewindowMs = Date.now() - 1262304000000;

    vm.cropNames = [];
    for (let property in agTypes.farmerCropNames) {
        vm.cropNames.push({
            nameId: property,
            value: agTypes.farmerCropNames[property]
        });
    }

    $scope.$watch(() => { return vm.device ? vm.device.label : null; }, (title) => {
        if (vm.ctx && title) {
            reset();
            vm.measurements = [];
            // vm.ctx.widgetTitle = title + ' (' + agUtils.getFarmerDeviceName(vm.device.type) + '): Measurements';
            let measurementsSubscriptionInfo = [{
                type: types.datasourceType.entity,
                entityType: types.entityType.device,
                entityId: vm.device.id.id,
                entityName: vm.device.label,
                timeseries: [{
                    name: "measurement"
                }]
            }];
            vm.ctx.subscriptionApi.createSubscriptionFromInfo(types.widgetType.timeseries.value, measurementsSubscriptionInfo, vm.measurementsSubscriptionOptions, false, true).then(
                (subscription) => {
                    vm.measurementsSubscription = subscription;
                }
            )
        }
    });

    function openAddMeasurementDialog($event) {
        if ($event) {
            $event.stopPropagation();
        }
        $mdDialog.show({
            controller: SuperProMeasurementAddDialogController,
            controllerAs: 'vm',
            templateUrl: superProMeasurementAddDialog,
            parent: angular.element($document[0].body),
            locals: {
                ctx: vm.ctx,
                device: vm.device,
                cropNames: vm.cropNames,
                editMeasurement: false
            },
            fullscreen: true,
            skipHide: true,
            targetEvent: $event
        });
    }

    function openEditMeasurementDialog($event, measurement) {
        if ($event) {
            $event.stopPropagation();
        }
        $mdDialog.show({
            controller: SuperProMeasurementAddDialogController,
            controllerAs: 'vm',
            templateUrl: superProMeasurementAddDialog,
            parent: angular.element($document[0].body),
            locals: {
                ctx: vm.ctx,
                device: vm.device,
                cropNames: vm.cropNames,
                editMeasurement: measurement
            },
            fullscreen: true,
            skipHide: true,
            targetEvent: $event
        });
    }

    function isCustomer() {
        if (userService.getAuthority() === 'CUSTOMER_USER') {
            return true;
        }
    }

    function onDataUpdated(subscription) {
        let data = angular.toJson(subscription.data);
        if (vm.latestData && (vm.latestData === data)) {
            return;
        } else {
            vm.latestData = data;
            if (subscription.data.length) {
                vm.measurements = subscription.data[0].data.map((value) => {
                    let res = angular.fromJson(value[1]);
                    res.ts = value[0];
                    return res;
                })
            }
        }
        $scope.$digest();
    }

    function onDataUpdateError(subscription, e) {
        $log.error(e);
    }

    $scope.$on('$destroy', () => {
        reset();
    });

    function getCropName(cropNameId) {
        if (vm.cropNames && vm.cropNames.length) {
            for (let i = 0; i < vm.cropNames.length; i++) {
                if (vm.cropNames[i].nameId === cropNameId) {
                    return vm.cropNames[i].value;
                }
            }
        }
        return "-";
    }

    function reset() {
        if (vm.measurementsSubscription) {
            vm.ctx.subscriptionApi.removeSubscription(vm.measurementsSubscription.id);
        }
    }
}

/*@ngInject*/
function SuperProMeasurementAddDialogController($scope, $mdDialog, $http, $timeout, types, agTypes, attributeService, ctx, device, cropNames, editMeasurement) {// eslint-disable-line

    let vm = this;

    vm.loading = false;
    vm.agTypes = agTypes;
    vm.ctx = ctx;
    vm.device = device;
    vm.cropNames = cropNames;
    vm.editMeasurement = editMeasurement;

    vm.measurementObj = {};
    vm.photo = "";
    vm.origPhoto = "";

    vm.currentDate = new Date();
    vm.measurementTime = new Date();
    vm.measurementDate = new Date();

    if (vm.editMeasurement) {
        vm.measurementObj = {
            moistureContent: vm.editMeasurement.moistureContent,
            comment: vm.editMeasurement.comment
        };
        vm.selectedCropObj = {
            nameId: vm.editMeasurement.cropType,
            value: agTypes.farmerCropNames[vm.editMeasurement.cropType]
        };
        vm.measurementTime = new Date(vm.editMeasurement.ts);
        vm.measurementDate = new Date(vm.editMeasurement.ts);

        if (vm.editMeasurement.latitude && vm.editMeasurement.longitude) {
            vm.loading = true;
            let attributes = [];
            attributes.push({key: 'latitude', value: vm.editMeasurement.latitude});
            attributes.push({key: 'longitude', value: vm.editMeasurement.longitude});
            attributeService.saveEntityAttributes(vm.device.id.entityType, vm.device.id.id, types.attributesScope.server.value, attributes).then(
                () => {
                    vm.loading = false;
                    $timeout(() => {
                        runLocationWatcher();
                    });
                },
                () => {
                    vm.loading = false;
                }
            );
        }

        attributeService.getEntityTimeseriesValues(vm.device.id.entityType, vm.device.id.id, ["photo"], vm.editMeasurement.ts-1, vm.editMeasurement.ts, 1).then(
            (data) => {
                if (data["photo"]) {
                    vm.photo = data["photo"][0].value;
                    vm.origPhoto = data["photo"][0].value;
                }
                $timeout(() => {
                    runPhotoWatcher();
                });
            }
        );
    }

    vm.addMeasurement = addMeasurement;
    vm.cancel = cancel;
    vm.getCropMatches = getCropMatches;

    $scope.$watch("vm.measurementTime", () => {
        let currentDate = new Date();
        if (vm.measurementTime.getTime() > currentDate.getTime()) {
            vm.measurementTime = currentDate;
        }
    });

    function addMeasurement() {
        vm.loading = true;
        vm.measurementDate.setHours(vm.measurementTime.getHours());
        vm.measurementDate.setMinutes(vm.measurementTime.getMinutes());

        vm.measurementObj.cropType = vm.selectedCropObj.nameId;

        let timeseriesObj = {
            values: {}
        };
        if (vm.editMeasurement) {
            timeseriesObj.ts = vm.editMeasurement.ts;
        } else {
            timeseriesObj.ts = vm.measurementDate.getTime();
        }

        let data = vm.ctx.defaultSubscription.data;
        if (data[0].data.length) {
            data.forEach((e) => {
                vm.measurementObj[e.dataKey.name] = e.data[0][1];
            })
        }

        timeseriesObj.values["measurement"] = angular.toJson(vm.measurementObj);
        let url = '/api/plugins/telemetry/' + vm.device.id.entityType + '/' + vm.device.id.id + '/timeseries/scope';
        $http.post(url, timeseriesObj).then(
            () => {
                if (vm.photo && (vm.photo !== vm.origPhoto)) {
                    let photoObj = {
                        ts: timeseriesObj.ts,
                        values: {
                            photo: vm.photo
                        }
                    };
                    $http.post(url, photoObj).then(
                        () => {
                            vm.loading = false;
                            $mdDialog.hide();
                        },
                        () => {
                            vm.loading = false;
                        }
                    );
                } else {
                    vm.loading = false;
                    $mdDialog.hide();
                }
            },
            () => {
                vm.loading = false;
            }
        );
    }

    function cancel() {
        $mdDialog.cancel();
    }

    function getCropMatches(cropSearchText) {
        let searchRegExp = new RegExp(cropSearchText, 'i');
        return vm.cropNames.filter((item) => {
            if (searchRegExp.test(item.value)) {
                return true;
            }
        });
    }

    function runLocationWatcher() {
        $scope.$watchGroup(['vm.ctx.defaultSubscription.data[0].data[0][1]', 'vm.ctx.defaultSubscription.data[1].data[0][1]'], (newValues) => {
            if (newValues[0] !== vm.editMeasurement.latitude || newValues[1] !== vm.editMeasurement.longitude) {
                $scope.theForm.$setDirty();
            }
        })
    }

    function runPhotoWatcher() {
        $scope.$watch('vm.photo', (newValue) => {
            if (newValue !== vm.origPhoto) {
                $scope.theForm.$setDirty();
            }
        })
    }
}